import { formatUtcTimestamp } from '../../../../utils/timezone-utils';

// Las fechas de incidencias llegan en UTC y se muestran en la zona seleccionada.
export const formatDateTime = (
  value: string | null | undefined,
  timeZone: string,
  locale = 'es-ES'
) => {
  if (!value) return '';

  return formatUtcTimestamp(value, timeZone, locale);
};

export const getIncidentPriorityColor = (priority?: string): string => {
    const normalized = String(priority || '').toLowerCase();

    if (normalized.includes('baja')) return '#28A745';
    if (normalized.includes('media')) return '#FFC107';
    if (normalized.includes('alta')) return '#FF5722';
    if (normalized.includes('critica') || normalized.includes('crítica'))
        return '#DC3545';

    return '#6C757D';
};

export const getIncidentStatusColor = (status?: string): string => {
    const normalized = String(status || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_');

    const map: Record<string, string> = {
        pendiente: '#e09e3b',
        asignada: '#70a7c0',
        asignadas: '#70a7c0',
        terminado: '#abb4aa',
        terminada: '#abb4aa',
        cerrada: '#abb4aa',
        cerrado: '#abb4aa',
        finalizada: '#abb4aa',
        finalizado: '#abb4aa',
        en_marcha: '#3fba5e',
    };

    return map[normalized] ?? '#6C757D';
};

export const getIncidentSeverityColor = (severity?: string): string => {
    const normalized = String(severity || '').toLowerCase();

    if (normalized.includes('leve') || normalized.includes('sin daño'))
        return '#53a366';

    if (normalized.includes('moderado') || normalized.includes('media'))
        return '#FFC107';

    if (normalized.includes('grave') || normalized.includes('catástrofico'))
        return '#FF5722';

    if (normalized.includes('crítico') || normalized.includes('critico'))
        return '#DC3545';

    return '#6C757D';
};

export const formatDateOnly = (date: Date): string => {
    return date.toISOString().split('T')[0];
};
